import type { MeterReadingInfo } from "../repository/PanelRepository";

/**
 * Puts the proposed reading back without changing whether the field is editable.
 *
 * `MeterReadingInfo` carries two unrelated things: the figure, and `canBeCorrected`, which the
 * dialog reads to decide whether the user may overwrite it. A proposal is only ever the figure - the
 * helpers that build one from a drying never set `canBeCorrected`, because the same reading is
 * offered read-only in one place and correctable in another.
 *
 * So restoring a proposal by assigning the whole object silently revokes the user's ability to type,
 * which is what made the end reading lock itself the moment the field was cleared or set back to the
 * start value. The decision belongs to the path that offered the field, not to the proposal.
 */
export function restoreProposedMeterReading(
  current: MeterReadingInfo,
  proposed: MeterReadingInfo
): MeterReadingInfo {
  return { ...proposed, canBeCorrected: current.canBeCorrected };
}
